export const parseImgURL = (imgURL: string) => {
  if (!imgURL.includes("ipfs://")) return imgURL;
  let output = imgURL.split("//")[1];
  output = "http://ipfs.io/ipfs/" + output;
  return output;
};
